export class KeyPairModel {
    public: string;
    private: string;
}
